<div class="row mb-3" [formGroup]="form">
  <div class="col-12">
    <label class="label">
      {{ 'company.event_feed.options.data_sources.title' | translate }}
      <nk-select-all-button
        [isAllSelected]="isAllDataSourceCategoriesSelected()"
        (setSelectAll)="selectAllDataSourceCategories($event)"></nk-select-all-button>
    </label>
    @if (dataSourceCategoryList$ | async; as dataSourceCategoryList) {
      @for (dataSourceCategory of dataSourceCategoryList; track dataSourceCategory.data_source_category_key) {
        <div class="form-group">
          <nk-checkbox [formControlName]="dataSourceCategory.data_source_category_key">
            {{ 'data_source_category.' + dataSourceCategory.data_source_category_key | translate }}
          </nk-checkbox>
        </div>
      }
    }
  </div>
</div>
@if (!hidePaymentRemarksSection() && (hasFeatureAndRoleAccess$ | async)) {
  @if ((companyUuid() && isPaymentRemarksOn() === false) || (sensitiveDataCompanyAccessEntity$ | async)) {
    <div class="row mb-4">
      <div class="col-12">
        <hr />
        <nk-payment-remarks-section
          [companyUuid]="companyUuid()"
          enableMessage="company.event_feed.options.payment_remarks.payment_remarks_enable_message"></nk-payment-remarks-section>
        <hr />
      </div>
    </div>
  }
}
